import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthedApiService} from '../../authed-api.service';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {style, trigger, state, transition, animate} from '@angular/animations';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {AccountInfoService} from '../../user/account-info.service';
import {CsvService} from '../../csv.service';
import {FilterPipe} from '../../filter.pipe';
import {v4 as uuid} from 'uuid';
import { DataTable } from 'angular2-datatable';
import {DifferentiateParametersComponent} from '../../executeemailtemplate/executeemailtemplate.component';
import {DataEditComponent} from './data-edit/data-edit.component';

interface RowOptions {
  [index: number]: {
    edit: boolean;
    type: 'old' | 'new';
    loading: boolean;
  };
}

@Component({
  selector: 'app-data-viewer',
  templateUrl: './data-viewer.component.html',
  styleUrls: ['./data-viewer.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DataViewerComponent implements OnInit {

  componentLoading = true;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('mf') dataTable: DataTable;

  data: any[];
  dataSource: MatTableDataSource<any>;
  displayedColumns = {}; // Add your column names here
  pageSize = 10;
  columnsToDisplay = [];
  userView = 'table';
  isEditComponent = false;

  editedData = {};
  rowOptions: RowOptions = {};
  dataIds = [];
  rowIndexKey = 'apID';

  filterData: any[];
  filteredItems: any;
  itemList: any[];
  searchText = '';
  filterPipe = new FilterPipe();
  settings: any = {text: 'Select attribute(s) to search instantly', badgeShowLimit: 2};
  tempCollectionSize: any;
  tempTotalPages: any;
  itemsPerPage = 20;

  isSubmitting = false;

  hasEdit = false;
  hasDelete = false;

  jsonEditorOptions = new JsonEditorOptions();
  oldData: any;
  newData: any;

  isBulkUploadComponent = false;
  bulkImportData: any;
  isBulkSubmitting = false;

  bulkChangeSubmitting = false;

  apiUrl: string;
  executorname: string;
  executorVersion: string;
  @ViewChild('editor') editor: JsonEditorComponent;

  constructor(
      private route: ActivatedRoute,
      private apiService: AuthedApiService,
      public dialog: MatDialog,
      private platform: LeftpanelComponent,
      private router: Router,
      private csvService: CsvService,
      public accountInfoService: AccountInfoService,
  ) {
    this.jsonEditorOptions.mode = 'code';
    this.jsonEditorOptions.modes = ['code', 'text', 'tree', 'view'];
    this.jsonEditorOptions.schema = '';
    this.jsonEditorOptions.statusBar = false;
    this.jsonEditorOptions.onChange = () => console.log(/*this.editor.get()*/);
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params && params.name && params.version) {
        this.executorname = params.name;
        this.executorVersion = params.version;
        this.apiService.getApiJoinsData(this.executorname, this.executorVersion).subscribe(resp => {
          let arr: any;
          arr = resp;
          this.componentLoading = false;
          this.initData(arr);
          // if (this.data && this.data.length > 0) {
          //   this.initTable();
          // }
        }, error => {
          this.platform.openSnackBar('Data could not be loaded. Please try again.', 'Error', {
            duration: 4000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          setTimeout(() => {
            this.router.navigateByUrl('/controlplane');
          }, 4000);
        });
      }
    });
  }

  refreshData() {
    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
      width: 'auto',
      height: 'auto',
    });

    this.apiService.getApiJoinsData(this.executorname, this.executorVersion).subscribe(resp => {
      let arr: any;
      arr = resp;
      this.componentLoading = false;

      this.initData(arr);
      loaderDialog.close();
    }, error => {
      this.platform.openSnackBar('Unable to refresh the data at the moment.', 'Error', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  initData(response) {
    this.data = response.data;
    this.hasEdit = response.edit ? response.edit : false;
    this.hasDelete = response.delete ? response.delete : false;
    this.columnsToDisplay = response.fieldsToDisplay;
    this.displayedColumns = response.displayFieldDetails;
    this.apiUrl = response.apiUrl;
    this.itemList = [];
    for (let t = 0; t < this.columnsToDisplay.length; t++) {
      const tempObj = {};
      tempObj['id'] = t;
      tempObj['itemName'] = this.columnsToDisplay[t];
      this.itemList.push(tempObj);
    }

    this.data.forEach((obj: any) => {
      const id = obj[this.rowIndexKey];
      if (!this.rowOptions[id]) {
        this.rowOptions[id] = {edit: false, type: 'old', loading: false};
      }
    });
  }

  saveChanges() {
    const filteredKeys = Object.keys(this.rowOptions).filter(key => {
      const row = this.rowOptions[key];
      return row.edit && row.type === 'old';
    });


    const dataToBechanged = [];

    for (const key of filteredKeys) {
      const index = this.data.findIndex(obj => obj[this.rowIndexKey] === key);
      if (index >= 0) {
        dataToBechanged.push({oldData: this.data[index], newData: this.editedData[key]});
      }
    }



    const insertKeys = Object.keys(this.rowOptions).filter(key => {
      const row = this.rowOptions[key];
      return row.edit && row.type === 'new';
    });



    const dataToBeinserted = [];

    for (const key of insertKeys) {
      const index = this.data.findIndex(obj => obj[this.rowIndexKey] === key);
      if (index >= 0) {
        const data = {
          data: this.editedData[key]
        };
        data[this.rowIndexKey] = key;
        dataToBeinserted.push(data);
      }
    }


    const promises = [];

    if (dataToBechanged.length > 0) {
      promises.push(this.bulkPushEditChanges(dataToBechanged));
    }
    if (dataToBeinserted.length > 0) {
      promises.push(this.bulkPushAddChanges(dataToBeinserted));
    }

    if (promises.length > 0) {
      this.isBulkSubmitting = true;
      Promise.all(promises)
          .then(async (results) => {
            this.isBulkSubmitting = false;
            this.refreshData();
          });
    }

  }

  bulkPushEditChanges(data) {
    for (const val of data) {
      this.rowOptions[val.oldData[this.rowIndexKey]].loading = true;
    }
    return new Promise((resolve, reject) => {
      this.apiService.submitApiJoinsEdit(this.executorname, this.executorVersion, {
        data: data
      }).subscribe(resp => {
        for (const val of data) {
          this.rowOptions[val.oldData[this.rowIndexKey]].edit = false;
          this.rowOptions[val.oldData[this.rowIndexKey]].loading = false;
          delete this.editedData[val.oldData[this.rowIndexKey]];
        }
        resolve(true);
      }, error => {
        for (const val of data) {
          this.rowOptions[val.oldData[this.rowIndexKey]].loading = false;
        }
      });
    });
  }

  bulkPushAddChanges(input) {
    const data = [];
    for (const val of input) {
      this.rowOptions[val[this.rowIndexKey]].loading = true;
      data.push(val['data']);
    }
    return new Promise((resolve, reject) => {
      this.apiService.submitApiJoinsInsert(this.executorname, this.executorVersion, {
        data: data
      }).subscribe(resp => {
        for (const val of input) {
          this.rowOptions[val[this.rowIndexKey]].loading = false;
        }
        resolve(true);
      }, error => {
        for (const val of input) {
          this.rowOptions[val[this.rowIndexKey]].loading = false;
        }
        resolve(false);
      });
    });
  }

  checkFilter() {
    if (!this.filterData || this.filterData === [] || this.filterData === null) {
      alert('Please select an attribute to filter.');
      this.searchText = '';
    } else {
      this.filteredItems = this.filterPipe.transform(this.data, this.searchText, this.filterData);
      // this.tempTotalPages = this.totalPages;
      // this.tempCollectionSize = this.collectionSize;
      if (this.filteredItems && this.searchText !== '') {
        this.tempCollectionSize = this.filteredItems.length;
        this.tempTotalPages = Math.ceil(this.tempCollectionSize / this.itemsPerPage);
      } else {
        // this.totalPages = this.tempTotalPages;
        // this.collectionSize = this.tempCollectionSize;
      }
    }
  }
  typeOfval(val) {
    return typeof val;
  }

  stringifyjson(val) {
    return JSON.stringify(val, null, 2).trim();
  }

  downloadCsv() {
    this.csvService.downloadFile(this.data, 'csv', this.columnsToDisplay);
  }

  // for mat-table
  initTable() {
    this.displayedColumns = {};
    for (const key of Object.keys(this.data[0])) {
      const [prefix, name] = key.split('_');
      this.displayedColumns[key] = `${name} (${prefix})`;
    }
    this.columnsToDisplay = ['actions', ...Object.keys(this.data[0])];
    this.dataSource = new MatTableDataSource(this.data);
    // setTimeout(() => {
    //   this.changeDetectorRef.detectChanges();
    // }, 100);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  createNewObject(originalObj) {
    const newObj = {};

    // tslint:disable-next-line:forin
    for (const key in originalObj) {
      const property = originalObj[key];

      if (property.editable) {
        newObj[key] = property.type === 'Double' ? 0 : '';
      } else {
        newObj[key] = null;
      }
    }

    newObj[this.rowIndexKey] = uuid();

    this.rowOptions[newObj[this.rowIndexKey]] = {edit: true, type: 'new', loading: false};

    const val = JSON.parse(JSON.stringify(newObj));
    delete val[this.rowIndexKey];
    this.editedData[newObj[this.rowIndexKey]] = val;

    return newObj;
  }

  insertNewRow() {
    if (!this.searchText) {
      this.data.push(this.createNewObject(this.displayedColumns));
      const totalPages = Math.ceil(this.data.length / this.dataTable.rowsOnPage);
      const lastPage = totalPages;
      const rowsOnPage = this.dataTable.rowsOnPage;
      this.dataTable.setPage(lastPage, rowsOnPage);
    } else {
      this.platform.openSnackBar('Please remove the search filter before adding new data.', 'Success', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  editRowInline(element) {
    this.rowOptions[element[this.rowIndexKey]].edit = !this.rowOptions[element[this.rowIndexKey]].edit;
    const val = JSON.parse(JSON.stringify(element));
    delete val[this.rowIndexKey];
    this.editedData[element[this.rowIndexKey]] = val;
  }

  openRowDialog(element, type = 'edit') {
    if (!this.editedData[element[this.rowIndexKey]]) {
      const val = JSON.parse(JSON.stringify(element));
      delete val[this.rowIndexKey];
      this.editedData[element[this.rowIndexKey]] = val;
    }
    const dialogRef = this.dialog.open(DataEditComponent, {
      disableClose: true,
      width: '500px',
      data: {
        columnsToDisplay: this.columnsToDisplay,
        displayedColumns: this.displayedColumns,
        values: JSON.parse(JSON.stringify(this.editedData[element[this.rowIndexKey]])),
        title: type === 'add' ? 'Add Data' : 'Update Data'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.isSubmit) {
          if (type === 'edit') {
            this.editedData[element[this.rowIndexKey]] = result.values;
            this.submitChangesForRowEdit(element, result.values);
          } else if (type === 'add') {
            const data = {
              data: JSON.parse(JSON.stringify(result.values))
            };
            data[this.rowIndexKey] = element[this.rowIndexKey];
            this.editedData[element[this.rowIndexKey]] = result.values;

            this.submitChangesForRowAdd([data]);
          }
        } else {
          if (result.values) {
            this.editedData[element[this.rowIndexKey]] = result.values;
            this.rowOptions[element[this.rowIndexKey]].edit = true;
          }
        }
      } else {
        if (!this.rowOptions[element[this.rowIndexKey]].edit) {
          delete this.editedData[element[this.rowIndexKey]];
        }
      }
    });
  }

  submitRowEditChanges(element) {
    this.submitChangesForRowEdit(element, this.editedData[element[this.rowIndexKey]]);
  }

  submitRowAddChanges(element) {
    const data = {
      data: JSON.parse(JSON.stringify(this.editedData[element[this.rowIndexKey]]))
    };
    data[this.rowIndexKey] = element[this.rowIndexKey];
    this.submitChangesForRowAdd([data]);
  }

  submitChangesForRowAdd(input, isBulk = false) {
    let data = [];
    if (isBulk) {
      this.isBulkSubmitting = true;
      data = input;
    } else {
      for (const val of input) {
        this.rowOptions[val[this.rowIndexKey]].loading = true;
        data.push(val['data']);
      }
    }
    this.apiService.submitApiJoinsInsert(this.executorname, this.executorVersion, {
      data: data
    }).subscribe(resp => {

      if (isBulk) {
        this.isBulkSubmitting = false;
      } else {
        for (const val of input) {
          this.rowOptions[val[this.rowIndexKey]].loading = false;
        }
      }
      let response: any;
      response = resp;
      let message = 'Your request has been submitted successfully';
      if (response && response.message) {
        message = response.message;
      }
      if (response && response.isCompleted) {
        this.refreshData();
      }
      this.platform.openSnackBar(message, 'Success', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }, error => {
      if (isBulk) {
        this.isBulkSubmitting = false;
      } else {
        for (const val of input) {
          this.rowOptions[val[this.rowIndexKey]].loading = false;
        }
      }
      this.platform.handleErrorGracefully(error, 'Unable to process the insert request at the moment');
      this.isSubmitting = false;
    });
  }

  submitChangesForRowEdit(oldData, newData) {
    this.rowOptions[oldData[this.rowIndexKey]].loading = true;
    this.apiService.submitApiJoinsEdit(this.executorname, this.executorVersion, {
      data: [{
        oldData: oldData,
        newData: newData
      }]
    }).subscribe(resp => {

      this.rowOptions[oldData[this.rowIndexKey]].edit = false;
      this.rowOptions[oldData[this.rowIndexKey]].loading = false;
      delete this.editedData[oldData[this.rowIndexKey]];

      this.isSubmitting = false;
      let response: any;
      response = resp;
      let message = 'Your request has been submitted successfully';
      if (response && response.message) {
        message = response.message;
      }
      if (response && response.isCompleted) {
        this.refreshData();
      }
      this.platform.openSnackBar(message, 'Success', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }, error => {
      this.rowOptions[oldData[this.rowIndexKey]].loading = false;
      this.platform.handleErrorGracefully(error, 'Unable to process the update request at the moment');
      this.isSubmitting = false;
    });
  }

  cancelRowAdd(item) {
    const id = item[this.rowIndexKey];
    if (id) {
      delete this.rowOptions[id];
      delete this.editedData[id];
    }

    const indexToRemove = this.data.findIndex(obj => obj[this.rowIndexKey] === item[this.rowIndexKey]);
    if (indexToRemove >= 0) {
      this.data.splice(indexToRemove, 1);
    }
  }

  cancelRowEdit(element) {
    this.rowOptions[element[this.rowIndexKey]].edit = !this.rowOptions[element[this.rowIndexKey]].edit;
    delete this.editedData[element[this.rowIndexKey]];
  }

  editRow(element) {
    this.oldData = JSON.parse(JSON.stringify(element));
    this.newData = JSON.parse(JSON.stringify(element));
    this.isEditComponent = true;
  }

  // will not work because of payload
  submitChanges() {
    if (this.editor.isValidJson()) {
      this.isSubmitting = true;
      this.apiService.submitApiJoinsEdit(this.executorname, this.executorVersion, {
        oldData: this.oldData,
        newData: this.editor.get()
      }).subscribe(resp => {

        this.isSubmitting = false;
        let response: any;
        response = resp;
        let message = 'Your request has been submitted successfully';
        if (response && response.message) {
          message = response.message;
        }
        if (response && response.isCompleted) {
          this.refreshData();
        }
        this.platform.openSnackBar(message, 'Success', {
          duration: 4000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }, error => {
        this.platform.handleErrorGracefully(error, 'Unable to process the update request at the moment');
        this.isSubmitting = false;
      });
    } else {
      this.platform.openSnackBar('Please enter valid JSON data and then try again.', 'Error', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.isSubmitting = false;
    }
  }

  deleteRow(element: any) {
    if (confirm('Are you certain that you wish to delete this data? Doing so will result ' +
        'in the deletion of all individual table data that is associated with this API Joins data.')) {
      this.apiService.submitApiJoinsDelete(this.executorname, this.executorVersion, {
        oldData: element,
        newData: element
      }).subscribe(resp => {

        let response: any;
        response = resp;
        let message = 'Your request has been submitted successfully';
        if (response && response.message) {
          message = response.message;
        }
        if (response && response.isCompleted) {
          this.refreshData();
        }
        this.platform.openSnackBar(message, 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }, error => {
        this.platform.handleErrorGracefully(error, 'Unable to process the delete request at the moment');
      });
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  bulkInsertData() {
    this.submitChangesForRowAdd(this.bulkImportData, true);
  }

  bulkInsertFileUploaded(files) {
    if (files && files.length > 0) {
      const file = files.item(0);

      // Check if file type is CSV or JSON
      if (file.type === 'text/csv' || file.type === 'application/json') {
        const reader = new FileReader();

        reader.onload = (event: any) => {
          const contents = event.target.result;
          const data = file.type === 'text/csv' ? this.csvToJsonModified(contents, this.columnsToDisplay,
              this.displayedColumns) : JSON.parse(contents);

          this.bulkImportData = data;
        };

        reader.readAsText(file);
      } else {
        this.platform.openSnackBar('Input must me a JSON/CSV file', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    }
  }

  csvToJsonModified (csv, columnsToDisplay, displayedColumns) {
    const lines = csv.split('\n');
    const result = [];

    const headers = lines[0].split(',').map(header => header.trim());

    const columnMappings = {};

    for (const column of columnsToDisplay) {
      const mapping = displayedColumns[column];
      if (mapping.editable) {
        columnMappings[column] = {
          displayName: mapping.displayName,
          type: mapping.type
        };
      }
    }

    for (let i = 1; i < lines.length; i++) {
      const obj = {};

      const currentLine = lines[i].split(',').map(header => header.trim());

      for (let j = 0; j < headers.length; j++) {
        if (headers[j] in columnMappings) {
          const column = headers[j];
          const value = currentLine[j].replace(/"/g, '');

          if (columnMappings[column].type === 'Double') {
            obj[column] = Number(value);
          } else if (columnMappings[column].type === 'Boolean') {
            obj[column] = Boolean(value) && (value.toLowerCase() === 'true' || Number(value) === 1);
          } else {
            obj[column] = value;
          }
        }
      }

      result.push(obj);
    }

    return result;
  }


  csvToJson(csv) {
    const lines = csv.split('\n');
    const result = [];
    const headers = lines[0].split(',');

    for (let i = 1; i < lines.length; i++) {
      const obj = {};
      const currentLine = lines[i].split(',');

      for (let j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentLine[j];
      }

      result.push(obj);
    }

    return result;
  }
}
